module.exports = __webpack_public_path__ + "img/1f404.0d3f1a0.svg";